import { render, staticRenderFns } from "./PassiveStockProducts.vue?vue&type=template&id=3cfbe190&scoped=true"
import script from "./PassiveStockProducts.vue?vue&type=script&lang=js"
export * from "./PassiveStockProducts.vue?vue&type=script&lang=js"
import style0 from "./PassiveStockProducts.vue?vue&type=style&index=0&id=3cfbe190&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbe190",
  null
  
)

export default component.exports